import { type ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Suspense as ReactSuspense } from 'react';

type Props = {
  fallback?: ReactNode;
  children: ReactNode;
  // Set inside react-three-fiber trees, where a DOM `<span>` is not a valid
  // child of `<group>`/`<mesh>`/etc. and would crash the renderer.
  r3f?: boolean;
};

const SuspenseFallback = ({ children }: { children: ReactNode }) => (
  <span data-suspended="" aria-busy="true" style={{ display: 'contents' }}>
    {children}
  </span>
);

// Wraps React's Suspense so every fallback carries a `data-suspended`
// marker (queryable by tests) and `aria-busy="true"`. Tests can wait on the
// marker to be removed before asserting on the resolved tree, eliminating
// races against `lazy()` chunk loads. Caller's fallback still renders.
export const Suspense = ({ fallback = null, children, r3f = false }: Props) => (
  <ReactSuspense
    fallback={r3f ? fallback : <SuspenseFallback>{fallback}</SuspenseFallback>}
  >
    {children}
  </ReactSuspense>
);
